export const InvalidDocumentCategoryErrorToast = () => (
    <div>
        The selected document category is no longer available. Please refresh
        the page and try again.
    </div>
);
